// The `VITE_NODE_ENV` values validated in `~/utils/env.server.ts`
// (`z.enum(['dev', 'qa', 'prod', 'local'])`).
export const env = {
  NODE_ENV: {
    LOCAL: 'local' as const,
    DEV: 'dev' as const,
    QA: 'qa' as const,
    PROD: 'prod' as const,
  },
}
